<div class="company-list">
  <div class="active-company">
    <div class="title">
      {{ "company-switcher.title.active-company" | translate }}:
    </div>
    <app-company-badge
      [companyName]="activeCompany"
      [isSwitcher]="false"
    ></app-company-badge>
    <div class="company-info">
      <div class="company-name">{{ activeCompany }}</div>
    </div>
  </div>
  <div class="label">
    {{ "company-switcher.label.switch-to-company" | translate }}:
  </div>
  <div class="input-container">
    <app-search-input
      (inputChanged)="onFilterChange($event)"
    ></app-search-input>
  </div>
  <div class="companies">
    @if (loading()) {
      <div class="loading">
        <app-loading [size]="'2x'"></app-loading>
      </div>
    } @else {
      <div class="companies-scroll">
        @for (company of companies(); track company.id) {
          <div
            class="company-row dropdown-item"
            (click)="selectCompany(company)"
          >
            <div class="company-item">
              <app-company-badge
                [companyName]="company.name"
                [isSwitcher]="false"
                [isDropDownItem]="true"
              ></app-company-badge>
              <div class="company-meta">
                <div class="company-name">
                  {{ company.name }} ({{ company?.country?.name }})
                </div>
                <div class="account-type-name">
                  <div class="meta-label">
                    {{ "company-switcher.label.account-type" | translate }}:
                  </div>
                  {{ company?.account_type?.name }}
                </div>
                <div class="parent-company-name">
                  <div class="meta-label">
                    {{ "company-switcher.label.parent-company" | translate }}:
                  </div>
                  {{ company?.parent_company?.name }}
                </div>
              </div>
            </div>

            <div class="is-active">
              @if (company.is_active) {
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (moreCount() > 0) {
      <div class="more">
        <a (click)="loadMore()" class="show-more-link">
          {{
            "company-switcher.button.show-all"
              | translate: { count: moreCount() }
          }}
        </a>
      </div>
    }
  </div>
</div>
